import { Outlet } from '@tanstack/react-router';
import { BrandMark, useBranding } from './branding';

/** Full-screen layout for pages outside the app shell (sign-in, waiting for approval). */
export function BlankLayout() {
  const { name } = useBranding();
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-surface px-4 py-10">
      <div className="mb-6 flex items-center gap-2">
        <BrandMark size="md" />
        <span className="text-lg font-semibold">{name}</span>
      </div>
      <div className="w-full max-w-sm">
        <Outlet />
      </div>
    </div>
  );
}
